import { jsx as _jsx } from "react/jsx-runtime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { Button, IconButton } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
// Standard card action affordances (LS-389): "See All" is a labelled link to a
// full read-only view; "Manage" is a compact, uniform edit icon; "Add" is a
// compact link straight to an add flow (e.g. the squad card's add-player picker).
export var SeeAllButton = function (_a) {
    var to = _a.to;
    return (_jsx(Button, { component: RouterLink, to: to, size: "small", endIcon: _jsx(ChevronRightIcon, {}), sx: { textTransform: "none" }, children: "See All" }));
};
export var AddButton = function (_a) {
    var to = _a.to, _b = _a.title, title = _b === void 0 ? "Add" : _b;
    return (_jsx(IconButton, { component: RouterLink, to: to, size: "small", color: "primary", "aria-label": title, title: title, children: _jsx(PersonAddAlt1Icon, { fontSize: "small" }) }));
};
export var ManageButton = function (_a) {
    var to = _a.to, onClick = _a.onClick;
    return to ? (_jsx(IconButton, { component: RouterLink, to: to, size: "small", color: "primary", "aria-label": "Manage", title: "Manage", children: _jsx(EditIcon, { fontSize: "small" }) })) : (_jsx(IconButton, { onClick: onClick, size: "small", color: "primary", "aria-label": "Manage", title: "Manage", children: _jsx(EditIcon, { fontSize: "small" }) }));
};
